import React from 'react';

import { TableTr, TableTd } from 'design/table';
import { useIntlDictionary } from 'hooks/useIntlDictionary';
import { normalizeProfileLike } from 'utils/profileLikeUtils';
import { TextComponent } from 'design/text/textComponents';
import { Bill } from 'types/state/bill';

type Props = {
  bill: Bill;
  active: boolean;
  onClick(id: number): void;
};

export const BillsTableRow = (props: Props) => {
  const { bill, active, onClick } = props;

  const {
    billsTableColumns: ownDictionary,
    shared: sharedDictionary,
  } = useIntlDictionary();

  const onRowClick = React.useCallback(() => {
    onClick(bill.id);
  }, [onClick, bill.id]);

  const issuedAtText = bill.issuedAt
    ? sharedDictionary.dates.calendarDateWithTime(new Date(bill.issuedAt))
    : '-';

  return (
    <TableTr active={active} onClick={onRowClick}>
      <TableTd text={`${bill.id}`} />
      <TableTd text={bill.bankAccount ? bill.bankAccount.unp : '-'} />
      <TableTd text={bill.userProfile.company} />
      <TableTd text={normalizeProfileLike(bill.userProfile).toFullName()} />
      <TableTd
        text={ownDictionary.residentValueText(bill.userProfile.resident)}
      />
      <TableTd
        text={sharedDictionary.paymentTransactionText({
          amount: bill.amount,
          currency: 'USD',
        })}
      />
      <TableTd
        text={
          bill.amountEUR && !bill.userProfile.resident
            ? sharedDictionary.paymentTransactionText({
                amount: bill.amountEUR,
                currency: 'EUR',
              })
            : ''
        }
      />
      <TableTd
        text={
          bill.amountRUB && !bill.userProfile.resident
            ? sharedDictionary.paymentTransactionText({
                amount: bill.amountRUB,
                currency: 'RUB',
              })
            : ''
        }
      />
      <TableTd
        text={
          <TextComponent color={bill.paid ? 'primary' : 'critical'} size="s">
            {ownDictionary.paidValueText(bill.paid)}
          </TextComponent>
        }
      />
      <TableTd text={issuedAtText} />
    </TableTr>
  );
};
